import React, { FunctionComponent } from 'react';
import classnames from 'classnames';

const pClasses = (className?: string): string =>
  classnames('font-extrabold text-left md:text-center mt-18 mb-12 md:mt-12 md:mb-6 lg:my-10 mx-8 md:mx-0', className);

const NumberSectionTitle: FunctionComponent<React.PropsWithChildren<HTMLParagraphElement>> = ({
  children,
  className
}) => <p className={pClasses(className)}>{children}</p>;

export default NumberSectionTitle;
